import PropTypes from 'prop-types';
import classNames from 'classnames';

import './ListRow.scss';

const ListRow = ({ renderLeftBlock, renderRightBlock, withBorder }) => {
  const listRowClasses = classNames('list-row', {
    'list-row--withBorder': withBorder
  });

  return (
    <div className={listRowClasses}>
      {renderLeftBlock()}
      {renderRightBlock()}
    </div>
  );
};

ListRow.propTypes = {
  renderLeftBlock: PropTypes.func.isRequired,
  renderRightBlock: PropTypes.func.isRequired,
  withBorder: PropTypes.bool
};

ListRow.defaultProps = {
  withBorder: true
};

export default ListRow;
